import { render, staticRenderFns } from "./EmergencyControl.vue?vue&type=template&id=e131a962"
import script from "./EmergencyControl.vue?vue&type=script&lang=js"
export * from "./EmergencyControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports